import { useIdentity } from "../../../../../../../../hooks/use-identity";
import { useNotifySubscriberContactMethodsForLoggedInUser } from "../../../../../../hooks/useNotifySubscriberContactMethodsForLoggedInUser";
import { compareIdentifiers } from "../../../../../../util/compareIdentifiers";

export function useSubscriberContactMethodPlaceholderFlags() {
  const { subscriberContactMethods } = useNotifySubscriberContactMethodsForLoggedInUser();
  const identity = useIdentity();

  const userEmail = identity.email;
  const userPhone = identity.phone;
  const isUserEmailVerified = userEmail && !!identity["email-verified-at"];
  const isUserPhoneVerified = userPhone && !!identity["phone-verified-at"];
  const hasContactMethodForUserEmail = subscriberContactMethods?.some(
    (method) =>
      method.type === "Email" &&
      !!method.identifier &&
      !!userEmail &&
      compareIdentifiers(method.identifier, userEmail, "Email"),
  );
  const hasContactMethodForUserPhone = subscriberContactMethods?.some(
    (method) =>
      method.type === "Phone" &&
      !!method.identifier &&
      !!userPhone &&
      compareIdentifiers(method.identifier, userPhone, "Phone"),
  );
  const shouldShowEmailPlaceholder = !hasContactMethodForUserEmail && !!userEmail;
  const shouldShowPhonePlaceholder = !hasContactMethodForUserPhone && !!userPhone;

  return {
    shouldShowEmailPlaceholder,
    shouldShowPhonePlaceholder,
    isUserEmailVerified,
    isUserPhoneVerified,
    userEmail,
    userPhone,
  };
}
